import('@consumer/styles/swiper.scss') // Load styles asynchronously.

export { setupSwiper } from '@consumer/modules/swiperSetup'
